// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Import pages
import Form from "./pages/form";
import Card from "./pages/card";
import Navbar from "./components/nav-bar";
import TestForm from "./pages/form2";
import Table from "./pages/VendorTable";
import Actions from "./pages/VendorActions";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/auth/login";
import Register from "./pages/auth/register";
import ChangePassword from "./pages/auth/changePassword";
import Profile from "./pages/auth/profile";
import SecureAuditLog from "./pages/SecureAuditLog";

// Import PrivateRoute
import PrivateRoute from "./components/PrivateRoute";
import { PortalScopeProvider } from "./context/PortalScopeContext";

const App = () => {
  return (
    <Router>
      <PortalScopeProvider>
        <NavbarWithLocation />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> */}

          {/* Private Routes (Require authentication) */}
          <Route
            path="/form"
            element={
              <PrivateRoute
                element={<Form />}
                allowedRoles={["Admin", "User"]}
              />
            }
          />
          <Route
            path="/cards"
            element={
              <PrivateRoute
                element={<Card allowedRoles={["Admin", "User"]} />}
              />
            }
          />
          <Route
            path="/testform"
            element={
              <PrivateRoute
                element={<TestForm allowedRoles={["Admin", "User"]} />}
              />
            }
          />
          <Route
            path="/table"
            element={
              <PrivateRoute
                element={<Table />}
                allowedRoles={["Admin", "User"]}
              />
            }
          />
          <Route
            path="/actions"
            element={
              <PrivateRoute
                element={<Actions />}
                allowedRoles={["Admin", "User"]}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute
                element={<Dashboard />}
                allowedRoles={["Admin", "User"]}
              />
            }
          />
          <Route
            path="/register"
            element={
              <PrivateRoute element={<Register />} allowedRoles={["Admin"]} />
            }
          />
          <Route
            path="/change-password"
            element={
              <PrivateRoute
                element={<ChangePassword />}
                allowedRoles={["Admin", "User"]}
              />
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute
                element={<Profile />}
                allowedRoles={["Admin", "User"]}
              />
            }
          />
          <Route
            path="/audit"
            element={
              <PrivateRoute
                element={<SecureAuditLog />}
                allowedRoles={["Admin"]}
              />
            }
          />
          <Route path="/unauthorized" element={<h2>Access Denied</h2>} />
        </Routes>
      </PortalScopeProvider>
    </Router>
  );
};

// NavbarWithLocation component to conditionally render the Navbar
const NavbarWithLocation = () => {
  const location = useLocation();
  const shouldShowNavbar = location.pathname !== "/login";

  return shouldShowNavbar ? <Navbar /> : null;
};

export default App;
